var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dropdown-button"},[_c('li',{on:{"click":function($event){_vm.showItems = !_vm.showItems}}},[_vm._t("default"),_c('ul',{staticClass:"items",class:{'show-items' : _vm.showItems}},_vm._l((_vm.items),function(item,idx){return _c('li',{key:idx,on:{"click":item.action}},[_vm._v(_vm._s(item.label))])}),0)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }